export default {
  authUser(state, data) {
    state.token = data.access_token;
  },

  setLoginCheck(state, data) {
    state.loginCheck = data;
  },

  setForgotCheck(state, data) {
    state.forgotCheck = data;
  },
  setRecoveryAuth(state, data) {
    state.registerToken = data.access_token;
    state.checkNewRegister = data.isNew;
  },
  setCaptcha(state, data) {
    state.captcha = data;
  },

  setLoadingBtn(state, data) {
    state.loadingBtn = data;
  },

  setImageUrl(state, data) {
    state.imageUrl = data;
  },
  setMultipleImageUrl(state, data) {
    state.multipleImage = data;
  },
  setMultipleImageUrl2(state, data) {
    state.multipleImage2 = data;
  },
  setThumbUrl(state, data) {
    state.thumbUrl = data;
  },
  setFileUrl(state, data) {
    state.fileUrl = data;
  },
  setVideoUrl(state, data) {
    state.videoUrl = data;
  },
  setSoundUrl(state, data) {
    state.soundUrl = data;
  },
  setUrl(state, data) {
    state.url = data;
  },
  setUrlsEmpty(state) {
    state.imageUrl = [];
    state.thumbUrl = [];
    state.fileUrl = [];
    state.videoUrl = [];
    state.soundUrl = [];
    state.url = [];
    state.multipleImage = [];
  },

  setAddUploaderCheck(state, data) {
    state.addUploaderCheck = data;
  },

  ///////////////////////////////////////////////////
  setCurrentUser(state, data) {
    state.userProfile = data;
  },

  setFiscalYear(state, data) {
    state.fiscalYear = data;
  },

  clearAuth(state) {
    state.token = null;
  },

  // Alert Handles ---------------------------------------

  setPostCheck(state, data) {
    state.postCheck = data;
  },

  setInfo(state, data) {
    state.checkAlert = 4;
    state.infoMessage = data;
    state.infoMessage = state.infoMessage.split("</br>").join("\n");
    state.infoMessage = state.infoMessage.split("<br/>").join("\n");
  },

  setWarning(state, data) {
    state.checkAlert = 3;
    state.warningMessage = data;
    state.warningMessage = state.infoMessage.split("</br>").join("\n");
    state.warningMessage = state.warningMessage.split("<br/>").join("\n");
  },

  setError(state, data) {
    state.checkAlert = 2;
    state.dangerMessage = data;  
    state.dangerMessage = state.infoMessage.split("</br>").join("\n");
    state.dangerMessage = state.dangerMessage.split("<br/>").join("\n");
  },

  setSuccess(state, data) {
    state.checkAlert = 1;
    state.successMessage = data;
  },

  expireAlert(state) {
    state.checkAlert = 0;
    state.successMessage = null;
    state.dangerMessage = null;
    state.warningMessage = null;
    state.infoMessage = null;
  },

  setLoading(state, data) {
    state.loadingCheck = data.status;
    state.loadingMessage = data.message;
  },

};
